import { portalKeys } from '../settings';

const getPortalKey = () => {
  const pathname = window.location.pathname.toLowerCase();
  const key = pathname.length === 1 ? 'qbe' : pathname.substr(pathname.lastIndexOf('/') + 1);

  return portalKeys.includes(key) ? key : undefined;
};

export default getPortalKey;
